import { Components, Theme } from '@mui/material/styles';

export default (): Components<Theme>['MuiTextField'] => {
  return {
    styleOverrides: {
      root: {
        // 'marginBottom': '10px',
        minWidth: '250px',
        minHeight: '56px',
        fontSize: '16px',
        '& .MuiInputBase-input': {
          fontSize: '16px'
        }
      }
    }
  };
};
